export default "__VITE_ASSET__C$cTgTCX__"